import { FileLink } from '@models/file-link.model';

import { ApiAdapter } from './adapter';

export class FileLinkAdapter extends ApiAdapter<FileLink> {
  get(json): FileLink {
    return new FileLink({
      id: json['id'],
      name: json['name'],
      mimeType: json['mime_type'],
      size: json['size'],
    });
  }
}
